import { User, VaccineConfig } from "@ambii-com/core";
import {
  liteCollections,
  liteQueryCollection,
  liteQueryCollectionLimited,
} from "~/utils/firestoreLite";

export async function readPatientByUserId(
  userId: string
): Promise<User | undefined> {
  const docs = await liteQueryCollectionLimited(
    liteCollections.patients,
    1,
    ["uid", "==", userId]
  );
  if (docs.length === 0) {
    return undefined;
  }
  return User.fromDoc(docs[0]);
}

export async function readVaccineConfigByClinicId(
  clinicId: string
): Promise<VaccineConfig | undefined> {
  const docs = await liteQueryCollectionLimited(
    liteCollections.vaccineConfigs,
    1,
    ["clinicId", "==", clinicId]
  );
  return VaccineConfig.fromDocs(docs)[0];
}

export async function readRelatedPatientsByUserId(userId: string) {
  const docs = await liteQueryCollection(
    liteCollections.relatedPatients,
    "uid",
    userId
  );
  return docs;
}

export async function readRelatedPatientsByParentUserId(parentUserId: string) {
  const docs = await liteQueryCollection(
    liteCollections.relatedPatients,
    "parentUserId",
    parentUserId
  );
  return docs;
}
